<template>
  <div class="invite-phone">
    <Icon></Icon>
    <Titles></Titles>
    <el-collapse-transition>
      <Error v-if="errorShow" :msg="errorMsg" v-on:closeErrorTip="closeErrorTip"></Error>
    </el-collapse-transition>
    <div class="country">
      <CountryCode style="float: left;" v-on:sendCountryCode="sendCountryCode"></CountryCode>
      <Inputs :type="'phone'" v-on:inputText="getAccount" v-on:enterInput="enterInput" style="width: 180px;float: right;margin-top: 0;"></Inputs>
    </div>
    <div class="code">
      <Inputs :type="'code'" v-on:inputText="getCode" v-on:enterInput="enterInput" style="width: 180px;margin-top: 0;float:left;"></Inputs>
      <GetCode style="float: right;" :type="0" :data="{countryCode, phone}" v-on:openErrorTip="openErrorTip"></GetCode>
    </div>
    <div class="button">
      <Buttons :type="'back'" style="width: 140px;float: left;margin-top: 0;"></Buttons>
      <Buttons ref=btn :type="'done'" :data="data" v-on:openErrorTip="openErrorTip" v-on:closeErrorTip="closeErrorTip" style="width: 140px;float: right;margin-top: 0;"></Buttons>
    </div>
    <div class="foot">
      <!-- <span>{{footText}}</span>
      <a href="https://www.craitapp.com/useragreement.php" target="_blank">{{footRouter}}</a> -->
      <a @click="verifyLater()">{{footText}}</a>
    </div>
  </div>
</template>

<script>
  import Icon from '../components/Icon'
  import Titles from '../components/Title'
  import Error from '../components/Error'
  import CountryCode from '../components/Countrycode'
  import Inputs from '../components/Inputs'
  import GetCode from '../components/GetCode'
  import Buttons from '../components/Buttons'
  import { transferData } from '../common/Common.js'
  import { errorFn } from '../common/ErrorMsg.js'
  import translate from '../common/Translate.js'
  export default {
    data () {
      return {
        loading: false,
        errorShow: false,
        data: {},
        phone: '',
        countryCode: '',
        // footText: translate('By registering, you agree to the '),
        footText: translate('Skip and verify later'),
        footRouter: translate('User agreement')
      }
    },
    components: {
      Icon, Titles, Error, CountryCode, Inputs, GetCode, Buttons
    },
    mounted () {
      this.data = transferData.getData()
      this.data['capture'] = ''
      transferData.deleteData()
    },
    methods: {
      sendCountryCode (data) {
        this.countryCode = data
        this.data['countryCode'] = this.countryCode
      },
      getAccount (data) {
        this.phone = data
        this.data['account'] = data
      },
      getCode (data) {
        this.code = data
        this.data['capture'] = this.code
      },
      // 关闭错误提示
      closeErrorTip () {
        errorFn.closeErrorTip(this)
      },
      // 弹出错误提示
      openErrorTip (msg) {
        this.closeErrorTip()
        errorFn.openErrorTip(msg, this)
      },
      // 输入框回车点击
      enterInput () {
        this.$refs.btn.clickBtn()
      },
      // 稍后验证
      verifyLater () {
        this.$refs.btn.clickBtn('verifyLater')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/css/_mixin.scss';
  .invite-phone {
    @include white-bg;
    min-height: 520px;
    margin-top: -260px;
    .country {
      width: 300px;
      height: 40px;
      margin: 0 auto;
      margin-top: 35px;
    }
    .code {
      width: 300px;
      height: 40px;
      margin: 0 auto;
      margin-top: 30px;
    }
    .button {
      width: 300px;
      height: 40px;
      margin: 0 auto;
      margin-top: 40px;
    }
    .foot {
      width: 100%;
      height: 14px;
      margin-top: 40px;
      margin-bottom: 75px;
      text-align: center;
      span {
        color: #939699;
      }
      a {
        color: #3f86de;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// Invitephone.vue?432cf534